//
// Multi - Padded text
//
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Caption } from 'ui/chandra'
import SelectBoxBase from './_bases/SelectBox'
import Selected from './_modifiers/Selected'

const SelectBox = styled(SelectBoxBase)`
  max-width: 100%;
  display: flex;
  padding: 15px;
  font-size: 15px;

  flex-basis: 50%;
  box-sizing: border-box;
  flex: 1;
  min-width: 260px;
  height: 46px;

     @media (max-width: 900px){
       margin: 5px 0
    };
  }

  :nth-child(even) {
    margin: 0px 0px 11px 30px;

    @media (max-width: 1200px){
      margin: 11px 0px 11px 0px
    };

    @media (max-width: 900px){
       margin: 5px 0
    };
  }

  @media all and (max-width: 1200px) {
    width: 230px;
  }

  @media all and (min-width: 1600px) {
    min-width: 40%;
  }
`
const SelectBoxSmaller = styled(SelectBoxBase)`
  display: flex;
  padding: 15px;
  font-size: 15px;
  margin: 11px 11px 11px 5px;
  flex-basis: 100%;
  box-sizing: border-box;
  flex: 1;
  @media all and (max-width: 1024px) {
    min-width: 45%;
    max-width: 45%;
    margin-right: auto;
  }
`

const SelectBoxWider = styled(SelectBoxBase)`
  display: flex;
  padding: 15px;
  font-size: 15px;
  margin: 11px 11px 11px 5px;
  flex-basis: 100%;
  box-sizing: border-box;
  flex: 1;
  min-width: 100%;

  @media all and (max-width: 1200px) {
    width: 320px;
    margin: 5px 0;
  }
`

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  @media all and (max-width: 1024px) {
    justify-content: center;
  }
`

const Select04 = ({
  component,
  handleSelect,
  isSelected,
  step,
  updatedSelected
}) => {
  const { maxSelections: max } = component

  let SelectBoxElement = component?.subQuestion
    ? SelectBoxSmaller
    : component.options && component.options.length > 6
    ? SelectBox
    : SelectBoxWider

  const deselectOption = component.options.filter(
    (option) => option.prompt === component.deselectOption
  )[0]

  const fontColor =
    updatedSelected.length === max ||
    (updatedSelected.includes('5') && step === 4)
      ? '#CCCCCC'
      : '#000000'

  return (
    <Container>
      {component.options &&
        component.options.map((option) => {
          const { prompt, slug } = option
          const selected = isSelected(option)
          const goalsSelector = prompt.replace(/\s+/g, '-').toLowerCase()

          return (
            <SelectBoxElement
              id={`select-four-${goalsSelector}`}
              key={slug}
              onClick={() => handleSelect(option, deselectOption)}
              selected={selected}
              color={fontColor}
            >
              {prompt && <Caption>{prompt}</Caption>}
              <Selected selected={selected} />
            </SelectBoxElement>
          )
        })}
    </Container>
  )
}

Select04.propTypes = {
  component: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  step: PropTypes.number
}

export default Select04
